import React, { useEffect, useState } from 'react';
import { settingsAPI } from '../services/api';
import './ScanSettings.css';

function ScanSettings() {
  const [settings, setSettings] = useState({
    auto_scan_enabled: true,
    auto_scan_buy: true,
    auto_scan_sell: true,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await settingsAPI.get();
      setSettings(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch settings:', error);
      setLoading(false);
    }
  };

  const handleToggle = async (key) => {
    const newSettings = { ...settings, [key]: !settings[key] };
    setSettings(newSettings);
    await saveSettings(newSettings);
  };

  const saveSettings = async (newSettings) => {
    setSaving(true);
    try {
      await settingsAPI.update(newSettings);
      console.log('Settings saved successfully');
    } catch (error) {
      console.error('Failed to save settings:', error);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="scan-settings">Loading settings...</div>;
  }

  return (
    <div className="scan-settings">
      <h3>Auto-Scan Settings</h3>
      
      <div className="setting-item">
        <label className="setting-label">
          <input
            type="checkbox"
            checked={settings.auto_scan_enabled}
            onChange={() => handleToggle('auto_scan_enabled')}
            className="setting-checkbox"
          />
          <span className="setting-text">Enable Auto-Scan</span>
        </label>
        <p className="setting-description">
          Automatically scan popular stocks every 5 minutes
        </p>
      </div>

      {settings.auto_scan_enabled && (
        <div className="signal-filters">
          <p className="filter-title">Show signals for:</p>
          
          <div className="setting-item">
            <label className="setting-label">
              <input
                type="checkbox"
                checked={settings.auto_scan_buy}
                onChange={() => handleToggle('auto_scan_buy')}
                className="setting-checkbox"
              />
              <span className="setting-text signal-buy">Buy Signals</span>
            </label>
          </div>

          <div className="setting-item">
            <label className="setting-label">
              <input
                type="checkbox"
                checked={settings.auto_scan_sell}
                onChange={() => handleToggle('auto_scan_sell')}
                className="setting-checkbox"
              />
              <span className="setting-text signal-sell">Sell Signals</span>
            </label>
          </div>
        </div>
      )}

      {saving && <p className="saving-indicator">Saving...</p>}
    </div>
  );
}

export default ScanSettings;
